/* global process */
import * as D from './deps';
import CrosstabReducer from './reducer';
import CrosstabWatchers from './sagas/watchers';
import * as CrosstabWorkers from './sagas/workers';
import * as CrosstabUtils from './utils';

export default D.createDomainModule({
  name: 'crosstab',
  components: null,
  reducer: CrosstabReducer,
  onLoad(store) {
    CrosstabUtils.receiveIncomingActions(store);
    window.addEventListener('unload', () => {
      if (CrosstabUtils.isCurrentlyPlayingTab(store.getState())) {
        CrosstabUtils.sendAction(CrosstabUtils.setCurrentlyPlayingTabId(null));
        CrosstabUtils.setCurrentlyPlayingTabId(null);
      }
    });
    if (process.env.NODE_ENV !== 'test') {
      return this.runSaga(store, CrosstabWorkers.initialize).toPromise();
    }
  },
  onStart() {
    this.registeredHandlers = D.registerHandlers(CrosstabWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
